import { useQuery } from "@tanstack/react-query";
import { Descriptions, Skeleton, Typography } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { fetchDossierById } from "../../../../lib/api/resources/dossiers";

const { Text } = Typography;

export const ChatDossierInfo = ({ dossierId }: { dossierId: string }) => {
  const dossierQuery = useQuery({
    queryKey: ["dossier", dossierId],
    queryFn: () => fetchDossierById(dossierId),
  });

  if (dossierQuery.isLoading) {
    return <Skeleton active paragraph={{ rows: 4 }} />;
  }

  const dossier = dossierQuery.data;

  if (!dossier) {
    return (
      <Text type="secondary" style={{ fontSize: 12 }}>
        Dossier niet gevonden.
      </Text>
    );
  }

  const driverName =
    dossier.driver?.fullName ?? dossier.driver?.person?.fullName ?? "—";
  const plate = dossier.vehicle?.licensePlate?.identifier ?? "—";
  const vehicle = [dossier.vehicle?.brand, dossier.vehicle?.model]
    .filter(Boolean)
    .join(" ");
  const leaseCompany = dossier.leaseCompany?.name ?? "—";

  return (
    <Descriptions
      size="small"
      column={1}
      colon={false}
      styles={{
        label: { fontSize: 12, color: "rgba(0,0,0,0.45)" },
        content: { fontSize: 12, justifyContent: "flex-end", textAlign: "end" },
      }}
      items={[
        {
          key: "driver",
          label: "Berijder",
          children: driverName,
        },
        {
          key: "plate",
          label: "Kenteken",
          children: plate,
        },
        ...(vehicle
          ? [{ key: "vehicle", label: "Voertuig", children: vehicle }]
          : []),
        {
          key: "lease",
          label: "Leasemaatschappij",
          children: leaseCompany,
        },
        ...(dossier.damageNumber
          ? [
              {
                key: "damage",
                label: "Schadenummer",
                children: dossier.damageNumber,
              },
            ]
          : []),
        {
          key: "link",
          label: "Dossier",
          children: (
            <Link to={`/claims/dossiers/${dossier.id}`}>
              Openen <ExportOutlined />
            </Link>
          ),
        },
      ]}
    />
  );
};
